<template>
  <div class="box">
    <div class="info">
      <span class="filename">{{file.name}}</span>
    </div>
    <span v-if="error" class="error">error</span>
    <button v-if="midiData" @click="downloadMidi">Download Midi</button>
  </div>
</template>

<script>

function fileReader(file) {
  return new Promise((resolve) => {
    var fr = new FileReader();  
    fr.onload = (e) => resolve(e.target.result)
    fr.readAsArrayBuffer(file)
  });
}

function bin2string(array){
	var result = "";
	for(var i = 0; i < array.length; ++i){
		result+= (String.fromCharCode(array[i]));
	}
	return result;
}

export default {
  name: 'AifFile',
  props: ['file'],
  async created () {
    this.loading = true
    if (!this.file) {
      this.loading = false
      return
    }
    let view = new DataView(await fileReader(this.file))
    let offset = 0
    let aiffFORM = bin2string(new Uint8Array(view.buffer.slice(offset, offset + 4)))
    if (aiffFORM !== 'FORM') {
      this.loading = false
      this.error = true
      return
    }
    offset += 4
    const aiffFileSize = view.getUint32(offset, false)
    offset += 4
    let aiffAIFF = bin2string(new Uint8Array(view.buffer.slice(offset, offset + 4)))
    if (aiffAIFF !== 'AIFF') {
      this.loading = false
      this.error = true
      return
    }
    offset += 4
    //console.log(bin2string(new Uint8Array(view.buffer.slice(8, 12))))
    while (offset < aiffFileSize - 8) {
      const magic = bin2string(new Uint8Array(view.buffer.slice(offset, offset+4)))
      //console.log('magic', magic)
      offset += 4
      const chunkSize = view.getUint32(offset, false)
      //console.log('chunkSize', chunkSize)
      offset += 4
      if (magic === '.mid') {
        this.midiData = view.buffer.slice(offset, offset + chunkSize)
      }
      offset += chunkSize
    }
    this.loading = false
  },
  methods: {
    downloadMidi () {
      const a = document.createElement("a")
      document.body.appendChild(a)
      a.style = "display: none"
      a.href = window.URL.createObjectURL(new Blob([this.midiData]))
      a.download = this.file.name + '.MID'
      a.click()
      //window.URL.revokeObjectURL(url);
      //saveData(data, fileName);
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      midiData: null,
    }
  }
}
</script>

<style scoped lang="scss">
  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1em;
    position: relative;
    height: 80px;
    border: 5px solid orange;
    border-radius: 1em;
    padding: 1em;
    background: #eee;
    text-align: center;
    font-size: 2em;
    button {
      font-size: 0.8em;
      width: 6em;
      background-color: orange;
      padding:0.5em;
      border: none;
      border-radius: 0.5em;
    }
}
</style>
